<template lang="html">
  <b-row align-h="center">
    <b-col md="6">
      <ExtForm
        :formData="formData"
        :submitProxy="submitProxy"
        :loadProxy="loadProxy"
        submitBtnText="Сохранить изменения"
      >

        <b-form-fieldset
          label="Имя"
          :feedback = "errors.first('name')"
          :class="{'is-invalid': errors.has('name') }"
        >
          <input class="form-control" v-validate="'letters_only'" v-model="formData.name" name="name"/>
        </b-form-fieldset>
        <b-form-fieldset
          label="Фамилия"
          :feedback = "errors.first('surname')"
          :class="{'is-invalid': errors.has('surname') }"
        >
          <input class="form-control" v-validate="'letters_only'" v-model="formData.surname" name="surname"/>
        </b-form-fieldset>
        <b-form-fieldset
          label="Отчество"
          :feedback = "errors.first('patronymic')"
          :class="{'is-invalid': errors.has('patronymic') }"
        >
          <input class="form-control" v-validate="'letters_only'" v-model="formData.patronymic" name="patronymic"/>
        </b-form-fieldset>
        <b-form-fieldset
          label="Дата рождения"
          :feedback = "errors.first('birthdate')"
          :class="{'is-invalid': errors.has('birthdate') }"
        >
          <InlineDatepicker v-model="formData.birthdate" v-validate="'required|date'" name="birthdate"/>
        </b-form-fieldset>
        <b-form-fieldset
          label="Email"
          :class="{'is-invalid': errors.has('email') }"
          :feedback = "errors.first('email')"
        >
          <input class="form-control" v-model.trim.lazy="formData.email" v-validate="'email'" name="email"/>
        </b-form-fieldset>
        <b-form-fieldset
          label="Контактный телефон"
          :class="{'is-invalid': errors.has('tel') }"
          :feedback = "errors.first('tel')"
        >
          <input class="form-control" v-mask="'+7 (###) ###-##-##'" v-model="formData.tel" name="tel"/>
        </b-form-fieldset>
      </ExtForm>
    </b-col>
  </b-row>
</template>

<script>
import ExtForm from '@/components/ExtForm'
import Datepicker from '@/components/Datepicker'
import InlineDatepicker from '@/components/InlineDatepicker'

export default {
  components: {
    ExtForm,
    Datepicker,
    InlineDatepicker
  },
  data () {
    return {
      formData: {
        name: '',
        surname: '',
        patronymic: '',
        birthdate: '',
        email: '',
        tel: ''
      },
      submitProxy: {
        url: 'api/user/' + this.$store.state.auth.user.id,
        method: 'post'
      },
      loadProxy: {
        url: 'api/user/' + this.$store.state.auth.user.id,
        method: 'get'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PersonalData.vue?c823a826